var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('div',{staticClass:"info-content"},[_c('h3',[_vm._v(_vm._s(_vm.title ? _vm.title : ''))]),_c('p',[_vm._v(_vm._s(_vm.body ? _vm.body : ''))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }